import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  carerStudents: {
    byId: {}
  },
  percenrage: {
    byId: {}
  },
  studentInfo: {
    byId: {}
  },
  sendEmail: {
    status: ''
  },
  saveAbsenceReason: {
    status: ''
  },
  actionsloading: false
});

export function absencesReducer(state = initialState, action) {
  // console.log('in absences reduecer....', action)
  switch (action.type) {
    case actionTypes.FETCH_CARER_STUDENTS:
    case actionTypes.FETCH_STUDENT_INFO:
    case actionTypes.FETCH_ABSENCES:
    case actionTypes.FETCH_ABSENCE_PERCENTAGE:
      return {
        ...state,
        byId: {},
        percenrage: {
          ...state.percenrage,
          byId: {}
        },
        actionsloading: true
      }
    case actionTypes.SAVE_ABSENCE_REASON:
      return {
        ...state,
        saveAbsenceReason: {
          ...state.saveAbsenceReason,
          status: 'sending'
        },
        actionsloading: true
      }
    case actionTypes.SEND_ABSENT_EMAIL:
      return {
        ...state,
        sendEmail: {
          ...state.sendEmail,
          status: 'sending'
        },
        actionsloading: true
      }
    case actionTypes.FETCH_CARER_STUDENTS_SUCCESS:
      return {
        ...state,
        carerStudents: {
          ...state.carerStudents,
          byId: action.payload.byId || {},
        },
        actionsloading: false
      }
    case actionTypes.FETCH_ABSENCES_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false
      }
    case actionTypes.FETCH_ABSENCE_PERCENTAGE_SUCCESS:
      return {
        ...state,
        percenrage: {
          ...state.percenrage,
          byId: action.payload.byId || {}
        },
        actionsloading: false
      }
    case actionTypes.FETCH_STUDENT_INFO_SUCCESS:
      return {
        ...state,
        studentInfo: {
          ...state.studentInfo,
          byId: action.payload.byId || {}
        },
        actionsloading: false
      }
    case actionTypes.SEND_ABSENT_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmail: {
          ...state.sendEmail,
          status: 'sended'
        },
        actionsloading: false
      }
    case actionTypes.SAVE_ABSENCE_REASON_SUCCESS:
      return {
        ...state,
        saveAbsenceReason: {
          ...state.saveAbsenceReason,
          status: 'sended'
        },
        actionsloading: false
      }
    default:
      return state;
  }
}